import { Box, FormControl, Input, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { SaveButton } from './index'
import { subscribeToSeminarlesson } from '../../../../redux/actions/seminarlessons'
import { IRootState } from '../../../../redux/types'

const SuscriptionLive = () => {
  const { t } = useTranslation(['global'])

  const dispatch = useDispatch()
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { seminarlesson_selected } = useSelector((state: IRootState) => state.seminarlesson)

  const handleSeminarRegistration = () => {
    dispatch(subscribeToSeminarlesson({ seminarlesson_id: seminarlesson_selected.id }))
  }

  return (
    <Grid sx={{ marginTop: '0' }}>
      <Grid
        container
        spacing={3}
        sx={theme => ({
          width: '100% !important',
          [theme.breakpoints.down('sm')]: {
            width: 'auto !important',
            '& .MuiGrid-item': {
              padding: 8
            }
          }
        })}
      >
        <Grid xs={12}>
          <Box pb={3}>
            <Typography
              sx={theme => ({ pb: 16, pl: 16, bl: `4px solid ${theme.palette.primary.main}` })}
              color="textPrimary"
              variant="h4"
            >
              {t('book-my-ticket')}
            </Typography>
            <Typography
              sx={theme => ({ pb: 16, pl: 16, bl: `4px solid ${theme.palette.primary.main}` })}
              variant="body1"
              color="textSecondary"
            >
              {t('client.register.register-live-message')}
            </Typography>
          </Box>
        </Grid>
        <Grid xs={12}>
          <Box mb={0.5}>
            <Typography>{t('name')}</Typography>
          </Box>
          <FormControl variant="filled" fullWidth>
            <Input
              placeholder={t('client.register.placeholder-name')}
              defaultValue={authUser !== null ? authUser.name : ''}
            />
          </FormControl>
        </Grid>
        <Grid xs={12}>
          <Box mb={0.5}>
            <Typography>{t('email')}</Typography>
          </Box>
          <FormControl variant="filled" fullWidth>
            <Input defaultValue={authUser !== null ? authUser.email : ''} placeholder={t('email')} />
          </FormControl>
        </Grid>
        <Grid xs={12}>
          {/* <TermsModal displayTerms={displayTerms} handleDisplayTerms={handleDisplayTerms} />  */}
          <Box display="flex" width="100%" justifyContent="center">
            <SaveButton onClick={() => handleSeminarRegistration()}>{t('continue')}</SaveButton>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SuscriptionLive
